import { useForm } from "react-hook-form";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import {
  useNotificationContext,
  useWingsContractWrite,
  Typography,
  Card,
  MyFormProvider,
  FlexCol,
  Button,
} from "../../../../shared";

export const UpdateArbitrager: React.FC = () => {
  const { showNotification } = useNotificationContext();
  const methods = useForm();
  const { reset, handleSubmit } = methods;

  const { writeContractAsync: updateArbitrager, isPending: isUpdating } =
    useWingsContractWrite();

  const onSubmit = async (data: any) => {
    await updateArbitrager(
      {
        abi: ArbitrageAbi,
        address: contractAddresses.Arbitrage,
        functionName: "updateArbitrager",
        args: [data.arbitragerAddress, data.status === "true"],
      },
      {
        onSuccess: () => {
          reset();
          showNotification({
            status: "success",
            content: <Typography>Arbitrager updated successfully</Typography>,
          });
        },
      }
    );
  };

  return (
    <Card className="w-2/3" hasBorder>
      <MyFormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <FlexCol className="w-full p-4 gap-4">
          <Typography>Arbitrage / updateArbitrager /</Typography>
          <FlexCol className="gap-3">
            <input
              {...methods.register("arbitragerAddress")}
              placeholder="Arbitrager Address"
              className="input input-bordered w-full"
            />
            <select
              {...methods.register("status")}
              className="select select-bordered w-full"
            >
              <option value={"true"}>True</option>
              <option value={"false"}>False</option>
            </select>
            <Button type="submit" loading={isUpdating}>
              Update Arbitrager
            </Button>
          </FlexCol>
        </FlexCol>
      </MyFormProvider>
    </Card>
  );
};
